export default function About() {
  return (
    <section id="about" data-testid="about-section" className="py-24 lg:py-32 bg-[var(--tt-cream)]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5">
          <div className="text-xs font-bold uppercase tracking-[0.22em] text-[var(--tt-orange)]">
            Hakkımızda
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[var(--tt-green-900)] mt-4 leading-[1.02]">
            Kilis&apos;in güvenilir hırdavat ve geri dönüşüm adresi.
          </h2>
        </div>
        <div className="lg:col-span-7 lg:pl-8 border-l-2 border-[var(--tt-green-800)]/15 lg:pt-2">
          <p className="text-base sm:text-lg text-[var(--tt-charcoal)]/80 leading-relaxed">
            Tuncay Ticaret olarak, Kilis Merkez&apos;de yıllardır esnafın, sanayicinin ve
            ev kullanıcısının yanındayız. Hırdavat tarafında geniş ürün yelpazemizle;
            geri dönüşüm tarafında ise vicdanlı tartı, doğru fiyat ve düzenli süreçle
            iş yapıyoruz. Hurdanın değeri kadar, çevrenin de değerli olduğuna inanıyoruz.
          </p>
          <div className="mt-10 grid sm:grid-cols-2 gap-6">
            {[
              {
                title: "Doğru malzeme",
                body: "Birinci sınıf hırdavat ve sarf malzemeleri — sahada işe yarayanı stoklarız.",
              },
              {
                title: "Adil tartı",
                body: "Geri dönüşümde şeffaf süreç ve doğru kantar. Hak edileni öderiz.",
              },
              {
                title: "Hızlı hizmet",
                body: "Esnaf hızıyla çözüm: telefonla bildirin, gelin, alın.",
              },
              {
                title: "Yerel bilgi",
                body: "Kilis ve çevresinin ihtiyacını ezbere biliyoruz.",
              },
            ].map((c) => (
              <div
                key={c.title}
                className="rounded-2xl bg-white border border-black/5 p-5 shadow-sm svc-card"
              >
                <div className="flex items-center gap-2">
                  <span className="w-2 h-2 rounded-full bg-[var(--tt-orange)]" />
                  <h3 className="font-display text-lg text-[var(--tt-green-900)]">{c.title}</h3>
                </div>
                <p className="text-sm text-[var(--tt-charcoal)]/70 mt-2 leading-relaxed">
                  {c.body}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
